import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Translator from '../../helpers/Translator';
import {DOMAIN} from '../FilterContainer';
import {clearFilter, selectTransferTimeFilters, selectTransferTimeFiltersUpdate} from '../../actions/FlightsActions';
import {registerAppliedFilter} from '../../actions/FilterGroupsActions';
import BaseFilterComponent from './BaseFilterComponent';
import {initialState} from '../../reducers/filters/TransferTimeFilterReducer';
import Timer from '../../helpers/Timer';
import DateTimeFormatter from '../../helpers/DateTimeFormatter';

class TransferTimeBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = 'transfer';
        this.name = 'Airport transfer time';
        this.urlEnabled = props.urlFilters.transfer && props.urlFilters.transfer !== initialState.selected;
    }

    componentDidMount() {
        ReactDOM.findDOMNode(this.form).setAttribute('mbsc-form', true);
        const self = this;

        this.timer = new Timer(300, () => {
            self.props.selectTransferTimeFiltersUpdate();
        });

        this.slider.addEventListener('change', (e) => {
            this.props.selectTransferTimeFilters(e.target.value);
            if (!this.timer.isRunning()) {
                this.timer.start();
            } else {
                this.timer.restart();
            }
        });

        super.componentDidMount();
    }

    renderLabel() {
        const value = this.getSelectedValue();
        const hrs = parseInt(value / 3600, 10);
        const mins = parseInt(value / 60, 10) - hrs * 60;

        return DateTimeFormatter.timeFormat(
            hrs,
            mins,
            this.translator.trans('h.'),
            this.translator.trans('m.')
        )
    }

    getSelectedValue() {
        return this.props.transfer.selected === 0 ? this.props.transfer.max : this.props.transfer.selected;
    }

    render() {
        this.translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div className={this.props.transfer.max === 0 ? 'd-none' : ''}>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="font-weight-bold">{this.translator.trans(this.name)}</div>
                    {this.renderClearFilterButton()}
                    <div className="clearfix mb-2">
                        <small>
                            <span className="text-muted">{this.translator.trans('to')}:</span> <span id="transfer-time-display">{this.renderLabel()}</span>
                        </small>
                    </div>
                    <div className="waavo-slider mobiscroll-refresh-element" id="transfer-slider" ref={(ref) => this.form = ref} style={{display: 'none'}}>
                        <input ref={(ref) => this.slider = ref} type="range" value={this.getSelectedValue()} min="2100" max={this.props.transfer.max}/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectTransferTimeFilters,
        selectTransferTimeFiltersUpdate,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        transfer: state.TransferTimeFilterReducer,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferTimeBlock);



// WEBPACK FOOTER //
// ./src/components/filters/TransferTimeBlock.js